export default __webpack_public_path__ + "static/PC-singapore-2-7c30dbf3a2f689604a143c8c2fa9b9dd.svg";